import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'app/store/store'
import { IEditTaskState } from './types/edit-task-interface'

const editTaskState = (state: RootState): IEditTaskState => state.editTask

export const EditTaskID = createSelector(
    [editTaskState],
    (state): string => state.EditTaskID,
)
export const EditTaskNumber = createSelector(
    [editTaskState],
    (state): string => state.EditTaskNumber,
)
export const EditTaskError = createSelector(
    [editTaskState],
    (state): string[] => state.errorEditTask,
)

export const EditTaskLoading = createSelector(
    [editTaskState],
    (state): boolean => state.isLoadingEditTask,
)